import React from 'react';
import PropTypes from 'prop-types';
import logo from './hittase.svg';

const HittaLogo = ({ size, classes }) => (
    <img className={classes} src={logo} alt="hitta.se" width={size} height={size} itemProp="logo" data-test="hittaLogo" />
);

HittaLogo.propTypes = {
    classes: PropTypes.string,
    size: PropTypes.number.isRequired,
};

HittaLogo.defaultProps = {
    classes: null,
};

export default HittaLogo;
